import React from "react";

const Logo = ({ logo, name, colorHeaderText, url, small = false }) => (
  <div>
    <a href={url} className="inline-block">
      {logo && "url" in logo && (
        <img
          src={logo["url"]}
          style={{
            height: `${
              small ? Math.floor(logo["height"] / 2) : logo["height"]
            }px`,
            width: `${small ? Math.floor(logo["width"] / 2) : logo["width"]}px`
          }}
          alt="Company Logo"
        />
      )}
      {!logo && (
        <h1
          className="text-xl font-semibold xl:text-2xl"
          style={{ color: colorHeaderText }}
        >
          {name}
        </h1>
      )}
    </a>
  </div>
);

export default Logo;
